import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate, TranslateChildFunction } from 'react-localize-redux';
import { Collapse } from 'reactstrap';
import { domainActions } from '../../../store/domainStore';
import { alertsActions } from '../../../store/alertsStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IdentitySection from './identitySection';
import CadastreSection from './cadastreSection';
import DateRange from './dateRange';
import { Formik, Form, Field } from "formik";
import { isNullOrUndefined } from "util";
import BbCheckbox from '../../styling/bbCheckbox';
import PopupMultiSelectButton from '../../common/popupMultiSelectButton';
import { connect as connectFormik } from 'formik';


const DOMAIN = "monitored-events-dictionary";

class SelectTree extends React.Component {
    state = {
        domainFiltered: null
    }

    componentDidMount() {
        this.props.ensureDomainData("monitored-events-dictionary");
    }

    componentDidUpdate() {
        if (!this.state.domainFiltered && this.props.domain[DOMAIN].requestResult && !this.props.domain[DOMAIN].isRequesting) {
            var dom = [];
            for (var i = 0; i < this.props.domain[DOMAIN].requestResult.length; i++) {
                var d = Object.assign({}, this.props.domain[DOMAIN].requestResult[i]);
                d.children = d.children.filter((n, index) => 
                d.children.findIndex(n2 => n2.value === n.value) === index);
                if (d.children.length > 0)
                    dom.push(d);
            }
            this.setState({ domainFiltered: dom });
        }
    }
    render() {
        var data = this.state.domainFiltered;
        if (isNullOrUndefined(data))
            return null;
        return (
            <div className='search-filter-content'>
                <ul className='filter-options'>
                    {this.renderFilterItems(this.props.filter.Key, this.props.filter.Name, data)}
                </ul>
            </div>
        );
    }


    renderFilterItems = (key, label, values) => {
        if (values === null || values === undefined)
            return null;

        const selection = isNullOrUndefined(this.props.formik.values[key]) ? [] : [...this.props.formik.values[key]];
        const renderAll = values.length <= 4;
        const items = renderAll ? values : values.slice(0, 4);
        return (
            <React.Fragment>
                {values.map(val => <li key={val.id}>
                    <BbCheckbox
                        label={val.label}
                        id={`${key}_${val.value}`}
                        value={this.getValue(val)}
                        onChange={(e) => this.onChange(key, [val], e)}
                    />
                </li>)}
                {!renderAll && (<li key={`${key}_${label}`}>
                    <div style={{ flexDirection: 'row' }}>
                        <label className="input-label">
                            <div className="text" style={{ marginLeft: '1.7em', paddingLeft: '.5em' }}>...</div>
                            <span className="bb-search-filter-link" style={{ right: '.5em' }}>
                                <PopupMultiSelectButton title={this.props.translate("Alerts.Event.Filter")} asLink={true} 
                                    customDomain={this.state.domainFiltered}
                                    popupSize={this.props.popupSize}
                                    selection={{ all: selection }}
                                    isList={true}
                                    handleChange={(values) => this.onPopupChange(key, values)}
                                    linkText={this.props.translate('Search.ShowMore')} />
                            </span>
                        </label>
                    </div>
                </li>)}
            </React.Fragment>
        );
    }

    renderCancel = (key) => {
        return (
            <div style={{ flexDirection: 'row' }}>
                <label className="input-label">
                    <div className="text" style={{ marginLeft: '1.7em', paddingLeft: '.5em' }}>&nbsp;</div>
                    <span className="bb-search-filter-link" style={{ right: '.5em', cursor: 'pointer' }} onClick={() => this.cancelSelection(key)}>
                        {this.props.translate('Common.Button.Cancel')}
                    </span>
                </label>
            </div>
        );
    }
    onPopupChange = (key, values) => {
        this.props.formik.setFieldValue(key, values.map(x => x.value));
    }

    onChange = (key, val, e) => {
        let selected = this.props.formik.values[key] || [];
        selected = this.onChangeChild(selected, val, e);
        this.props.formik.setFieldValue(key, selected);
    }

    onChangeChild = (selected, val, e) => {
        val.map(c => {
            if (e) {
                if (!selected.includes(c.value))
                    selected.push(c.value);
            }
            else
                selected.pop(c.value);
            if (c.children.length > 0)
                selected = this.onChangeChild(selected, c.children, e);
        });

        return selected;
    }

    getChildValue = (select, val, values) => {
        const key = this.props.filter.Key;
        val.map(c => {
                select.push(values.includes(c.value));
            if (c.children.length > 0)
                select = this.getChildValue(select, c.children, values);
        });

        return select
    }

    getValue = (val) => {
        const key = this.props.filter.Key;
        let select = [];
        if (isNullOrUndefined(this.props.formik.values[key]) || !Array.isArray(this.props.formik.values[key]))
            return false;
        select = this.getChildValue(select, [val], this.props.formik.values[key]);
        if (select.includes(true) && select.includes(false))
            return null;
        else if (select.includes(true) && !select.includes(false))
            return true;
        else
            return false
    }
}

export default withLocalize(connectFormik(connect(
    state => ({ domain: state.domain, alerts: state.alerts }),
    dispatch => bindActionCreators(({ ...domainActions, ...alertsActions }), dispatch),
)(SelectTree)))